import { Component, ElementRef, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, Renderer2 } from '@angular/core';
import { v4 as uuid } from 'uuid';

export interface MultiSelectItem {
  id: string;
  title: string;
  subtitle1?: string;
  subtitle2?: string;
  subtitle3?: string;
  action: () => any;
  checked: boolean,
  hide?: boolean,
  // The reporting_period this option represents, and whether it's loaded yet.
  periodValue?: string,
  willBeLoaded?: boolean,
}

@Component({
    selector: 'app-popover-menu-multi-select',
    templateUrl: './popover-menu-multi-select.component.html',
    styleUrls: ['./popover-menu-multi-select.component.scss'],
    standalone: false
})
export class PopoverMenuMultiSelectComponent implements OnInit, OnDestroy {
  @Input() multiSelectOptions: MultiSelectItem[];
  @Input() buttonText: string;
  @Output() selectOrDeselectAll = new EventEmitter<any>();

  checkboxUuid: string;

  private removeShownListener?: () => void;

  constructor(private elementRef: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.checkboxUuid = uuid();
    this.removeShownListener = this.renderer.listen(
      this.elementRef.nativeElement, 'shown.bs.dropdown', () => this.resetMenuScroll());
  }

  ngOnDestroy(): void {
    this.removeShownListener?.();
  }

  private resetMenuScroll(): void {
    const menu: HTMLElement | null = this.elementRef.nativeElement.querySelector('.dropdown-menu');
    if (menu) {
      menu.scrollTop = 0;
    }
  }

  triggerSelectOrDeselectAll() {
    this.selectOrDeselectAll.emit();
  }

  isSelectDeselectChecked() {
    return this.multiSelectOptions.some(option => option.checked === true);
  }

  noOptionsToDisplay() {
    return !this.multiSelectOptions.length || this.multiSelectOptions.every(option => option.hide === true);
  }

  toggleChecked(option) {
    option.checked = !option.checked
  }
}
